import {
  CarDetailsContainer,
  CheckoutCardWrapper,
  ContainerText
} from "./styles";
import DOMPurify from "isomorphic-dompurify";
import { Flex, Box } from "@acko-tech/building-blocks.ui.common";
import ImageContainer from "@components/imageContainer";

const MmvCardWithExpiry = ({ children, ...props }) => {
  const {regNo, mmv, actions, product, expiryText, src} = props || {};
  const { on_click } = actions || {};
  const iconSrc =
    product === "bike"
      ? "https://storefront-consumer-assets.s3.ap-south-1.amazonaws.com/static/sdui-common/bike_blur.svg"
      : "https://storefront-consumer-assets.s3.ap-south-1.amazonaws.com/static/sdui-common/car_blur.svg";

  return (
    <Box>
      <CheckoutCardWrapper>
        <CarDetailsContainer>
          <ImageContainer
            imgSrc={iconSrc}
            width={58}
            height={58}
            alt={"car details"}
          />
          <Flex flexDirection="column" style={{ gap: "4px" }}>
            <ContainerText
              dangerouslySetInnerHTML={{
                __html: DOMPurify.sanitize(mmv)
              }}
              />
            <ContainerText>{regNo}</ContainerText>
            <ContainerText dangerouslySetInnerHTML={{
                __html: DOMPurify.sanitize(expiryText)
              }}/>
          </Flex>
        </CarDetailsContainer>
          <ImageContainer
            imgSrc={src}
            width={30}
            height={30}
            alt={"car details"}
            onClick={() => {
              if (on_click?.length > 0) {
                on_click?.forEach((eachFunc: any) => {
                  typeof eachFunc.funCall === "function" &&
                    eachFunc.funCall(eachFunc.args);
                });
              }
            }}
          />
      </CheckoutCardWrapper>
    </Box>
  );
};

export default MmvCardWithExpiry;